import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {users} from "../../api/dummyAuth";
import { axiosInstance as axios, endpoint } from "../../api/axios";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUser } from '../../redux/slice/user';
import DrGadgetLogo from '../../assets/img/dr-gadget.png';
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import { useSnackbar } from "notistack";

const Login = () => {
  // const [phone, setPhone] = useState("");
  // const [formattedPhone, setFormattedPhone] = useState("");
  const [email, setEmail] = useState("");
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const dispatch = useDispatch();

   
  //  const formatPhoneNumber = (phone, countryCode) => {
  //   if (!phone) return phone;

    
  //   if (phone.startsWith(countryCode)) {
  //     return `0${phone.slice(countryCode.length)}`;
  //   }

  //   return phone;
  // };

  // const handlePhoneChange = (value, countryData) => {
  //   setPhone(value);

    
  //   const formatted = formatPhoneNumber(value, countryData.dialCode);
  //   setFormattedPhone(formatted);
  // };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };


  // const handleLogin = () => {
  //   const foundUser = users.find((user) => user.phone === formattedPhone);
  //   if (formattedPhone.length < 6) {
  //     enqueueSnackbar("Nomor handphone tidak valid", { variant: "error" });
  //     return;
  //   }else if(!foundUser){
  //     enqueueSnackbar("Nomor handphone tidak terdaftar", { variant: "error" });
  //     return;
  //   }
  //   dispatch(setUser({ phone: formattedPhone, isLoggedIn : true}));
  //   navigate('/pin');
  // };


  const handleLogin = async () => {

    if (email === "") {
      enqueueSnackbar("Email tidak boleh kosong", { variant: "error" });
      return;
    } else if (!email.includes("@")) {
      enqueueSnackbar("Format email tidak valid", { variant: "error" });
      return;
    }
    dispatch(setUser({ email: email, isLoggedIn : true}));
    navigate('/pin');
  };


  return (
    <>
     
      <Box
        sx={{
          position: "absolute",
          top: 30,
          width: "100%",
          textAlign: "center",
          zIndex: 10,
        }}
      >
       <img
        src={DrGadgetLogo} 
        alt="Dr Gadget Indonesia"
        style={{
          width: isMobile ? "80%" : "60%", 
          maxWidth: "15%",
          height: "auto",
          objectFit: "contain",
          boxShadow: "0 0 6px rgba(211, 205, 205, 0.5)",
        }}
      />
      </Box>

      <Box
        sx={{
          minHeight: "100vh",
          backgroundImage: "url('/background.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: isMobile ? 1 : 3,
          position: "relative",
        }}
      >
        <Container maxWidth="sm">
          <Paper
            elevation={isMobile ? 1 : 3}
            sx={{
              p: isMobile ? 2 : 5,
              borderRadius: isMobile ? 2 : 4,
              backgroundColor: "rgba(255, 255, 255, 0.8)", 
            }}
          >
            <Typography
              variant={isMobile ? "h6" : "h5"}
              gutterBottom
              color="text.secondary"
              sx={{ fontWeight: 500 }}
            >
              Selamat Datang di
            </Typography>
            <img
              src={DrGadgetLogo} 
              alt="Dr Gadget Indonesia"
              style={{
                width: isMobile ? "80%" : "60%", 
                maxWidth: "30%",
                height: "auto",
                objectFit: "contain",
                boxShadow: "0 0 6px rgba(211, 205, 205, 0.5)",
              }}
            />
            {/* <Typography
              variant="body2"
              color="text.secondary"
              mb={isMobile ? 2 : 3}
            >
              Silahkan masukan No. HP Anda
            </Typography> */}

            <Typography
              variant="body2"
              color="text.secondary"
              mb={isMobile ? 2 : 3}
            >
              Silahkan masukan Email Anda
            </Typography>

            {/* <Typography
              variant="subtitle2"
              gutterBottom
              color="text.secondary"
              sx={{ fontSize: isMobile ? 13 : 14 }}
            >
              Nomor Handphone
            </Typography> */}

            <Box sx={{ mb: isMobile ? 2 : 3 }}>
              {/* <PhoneInput
                country={"id"}
                value={phone}
                onChange={handlePhoneChange}
                inputStyle={{
                  width: "100%",
                  height: isMobile ? "38px" : "42px",
                  fontSize: "16px",
                  borderRadius: "8px",
                }}
                containerStyle={{ width: "100%" }}
              /> */}

            <TextField
                fullWidth
                size="small"
                variant="outlined"
                value={email}
                autoComplete="off"
                onChange={handleEmailChange}
                label="Email"
                sx={{
                  mb: 2,
                  borderRadius: 2,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailOutlinedIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            <Button
              variant="contained"
              color="success"
              fullWidth
              size={isMobile ? "medium" : "large"}
              onClick={handleLogin}
              sx={{ borderRadius: 999 }}
            >
              Lanjut
            </Button>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default Login;
